import { render, staticRenderFns } from "./addSidebarView.vue?vue&type=template&id=b888e386&scoped=true&"
import script from "./addSidebarView.vue?vue&type=script&lang=js&"
export * from "./addSidebarView.vue?vue&type=script&lang=js&"
import style0 from "./addSidebarView.vue?vue&type=style&index=0&id=b888e386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b888e386",
  null
  
)

export default component.exports